<template>
  <v-card>
    <v-card-title>
      ห้องเรียน 
      <v-spacer></v-spacer>
      <v-text-field
        v-model="pagination.q"
        append-icon="search"
        label="ค้นหา"
        single-line
        hide-details
        class="mr-3"
      ></v-text-field>
      <v-tooltip left>
        <v-btn color="teal" slot="activator" dark fab @click="addItem()">
          <v-icon>playlist_add</v-icon>
        </v-btn>
        <span>เพิ่มห้องเรียน</span>
      </v-tooltip>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-autocomplete
                    :items="buildingItems"
                    v-model="editedItem.building"
                    item-text="name"
                    item-value="id"
                    label="อาคาร"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="editedItem.name" label="ชื่อห้องเรียน"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="editedItem.floor" label="ชั้น"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="editedItem.capacity" label="ความจุ"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="editedItem.realCapacity" label="ความจุจริง"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-textarea multi-line label="หมายเหตุ" v-model="editedItem.remark"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn dark color="grey" @click="close">ยกเลิก</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark color="green" @click="save">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-data-table
    	:loading="loading"
      :headers="headers"
      :items="items"
      :total-items="totalItems"
    >
      <template slot="items" slot-scope="props">
      	<td>{{ props.item.name }}</td>
        <td>{{ props.item.floor }}</td>
        <td>{{ props.item.capacity }}</td>
        <td>{{ props.item.realCapacity }}</td>
        <td>{{ props.item.remark }}</td>
				<td class="text-xs-right">
					<v-tooltip left>
	          <v-icon
	          	slot="activator"        
	            color="blue"
	            class="mr-2"
	            @click="editItem(props.item)"
	          >
	            edit
	          </v-icon>
	          <span>แก้ไข</span>
      		</v-tooltip>
          <v-tooltip left>
	          <v-icon
	          	slot="activator"
	            color="red"
	            @click="deleteItem(props.item)"
	          >
	            delete
	          </v-icon>
	          <span>ลบ</span>
      		</v-tooltip>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ pagination.q }}" found no results.
      </v-alert>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import swal from 'sweetalert2'

export default {
  data () {
  	return {
  		dialog: false,
  		search: '',
  		headers: [
        { text: 'ห้องเรียน', align: 'left', sortable: true, value: 'name' },
        { text: 'ชั้น', align: 'left', sortable: true, value: 'floor' },
        { text: 'ความจุ', align: 'left', sortable: true, value: 'capacity' },
        { text: 'ความจุจริง', align: 'left', sortable: true, value: 'realCapacity' },
        { text: 'หมายเหตุ', align: 'left', sortable: false, value: 'name' },
        { text: '', sortable: false }
      ],
      editedIndex: -1,
      editedItem: { building: null, name: '', floor: '', capacity: '', realCapacity: '', remark: '' },
      defaultItem: { building: null, name: '', floor: '', capacity: '', realCapacity: '', remark: '' },
      pagination: {
        q: '',
        sortBy: 'name',
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
  	}
  },
  computed: {
  	...mapGetters({
      loading: 'building/loadingStatus',
      items: 'building/roomItems',
      buildingItems: 'building/buildingItems',
      totalItems: 'building/totalItems'
    }),
    formTitle () {
      return this.editedIndex === -1 ? 'เพิ่มห้องเรียน' : 'แก้ไขห้องเรียน'
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    }
  },
  created () {
    this.initialize(this.pagination)
  },
  mounted () {

  },
  methods: {
  	...mapActions({
      initialize: 'building/loadRoomItemsAsPage'
    }),
  	addItem () {
  		this.dialog = true
  	},
  	editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.items.indexOf(item)
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        console.log('swal', result.value)
        if (result.value) {
          const dispatch = 'building/deleteRoom'
		      this.$store.dispatch(dispatch, item)
		        .then((response) => {
		          setTimeout( ()=>this.initialize (this.pagination), 500)
		          this.close()
		        }).catch((error)=>{
		          console.log('initialize', error)
              swal('เกิดข้อผิดพลาด!', error.message, 'error')
		        })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
    	const dispatch =  this.editedIndex === -1 ? 'building/createRoom' : 'building/updateRoom'
      this.$store.dispatch(dispatch, this.editedItem)
        .then((response) => {
          setTimeout( ()=>this.initialize (this.pagination), 500)
          this.close()
        }).catch((error)=>{
          console.log('initialize', error)
        })
    }
  },
  watch: {
    'pagination.rowsPerPage' () {
      this.initialize(this.pagination)
    },
    'pagination.q' () {
      this.initialize(this.pagination)
    },
    'pagination.page' () {
      this.initialize(this.pagination)
    },
    'pagination.descending' () {
      this.initialize(this.pagination)
    },
    dialog (val) {
      val || this.close()
    }
  } 
}
</script>



// WEBPACK FOOTER //
// src/components/settings/building/dataTables/room.vue